    angular.module('files')
        .component('fileListSimple', {
            bindings: {
                type: '<',
                id: '<',
                disableUnbind: '<',
            },
            templateUrl: 'app/files/file-list-uploadable-simple.html',
            controller: function ($rootScope, $scope, $filter, FileAssociation, FileAssociationService) {
                this.$onInit = () => {
                    FileAssociation.get({type: $filter("lowercase")(this.type), id: this.id}).$promise.then(response => this.filesPage = response)
                }

                this.unbindFile = fileAssociation => {
                    FileAssociationService.unbind(fileAssociation, {type: this.type, id: this.id})
                }

                $scope.$on("file.saved", () => {
                    $rootScope.$broadcast('document.comments.reload', this.id)
                    this.$onInit()
                });
            }
        })
